<template>
  <div class="flex flex-row gap-2 items-center">
    <div class="secondary_medium w-[80%] p-3 flex flex-row !justify-start">
      <span class="text-[14px] text_color truncate">{{ disposition }}</span>
    </div>
    
    <button
      @click="handleRemove"
      class="secondary_medium size-8"
    >
      <ThemeImage
        :icon="imageNames.CROSS_GREY"
        alt="remove_disposition"
        class="size-4"
      />
    </button>
  </div>
</template>

<script setup>
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";

defineProps({
  disposition: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['remove']);

const handleRemove = () => {
  emit('remove');
};
</script>

